import { createContext } from "react"

/**
 * Permite que uma página substitua o rótulo do breadcrumb para o próprio
 * caminho (ex.: `/cadastro/localidades/:id` → "Editar localidade"), evitando
 * que o UUID do registro apareça na trilha de navegação.
 */
export interface BreadcrumbContextValue {
  overrides: Record<string, string>
  definir: (path: string, label: string) => void
  limpar: (path: string) => void
}

export const BreadcrumbContext = createContext<BreadcrumbContextValue | null>(null)
